import * as types from './actionTypes.predefinedScripts';
import { IGetPredefinedScriptsParam } from './saga.predefinedScripts';

export const getPredefinedScripts = ({ sluVersion }: IGetPredefinedScriptsParam) => ({
    type: types.GET_PREDEFINED_SCRIPTS_REQ,
    sluVersion
});